import { usePhotoAppsRouteLoaderData } from './appsRouteLoader'
import { Redirect } from '@jotta/ui/Redirect'

export function AppsRoute({ fallbackPath }: { fallbackPath: string }) {
  const url = usePhotoAppsRouteLoaderData() || fallbackPath
  return <Redirect to={url} reload></Redirect>
}
